import { Environments, PartialServiceMap } from '@innovyze/lib_get_service';
import { getRegionName } from '@innovyze/stylovyze';

import { constructAdskMoniker } from './cloudOS/monikers';

const config: PartialServiceMap = {
	[Environments.LOCAL]: {
		assets: 'https://saas-asset-management.info360-dev.com/dev',
		alertsManager: 'https://saas-alerts-management.info360-dev.com/dev',
		amInspection: 'https://saas-inspection-management.info360-dev.com/dev',
		tiles: 'https://tiles-dev.info360-dev.com/dev',
		incident: 'https://saas-incident-management.info360-dev.com/dev',
		entitlements: 'https://saas-auth.info360-dev.com/dev',
		// entitlements: 'http://localhost:3276/dev',
		edgeManager: 'https://saas-edge-manager.info360-dev.com/dev',
		billing: 'https://saas-billing.info360-dev.com/dev',
		looker: 'https://saas-looker.info360-dev.com/dev/looker',
		valueMapping: 'https://saas-value-mapping.info360-dev.com/dev',
		sensorGroup: 'https://saas-sensor-group.info360-dev.com/dev',
		liftStations: 'https://saas-lift-stations.info360-dev.com/dev',
		sensors: 'https://saas-sensor.info360-dev.com/dev',
		serviceIntegration:
			'https://saas-serviceintegration.info360-dev.com/dev',
		emaginOptimization:
			'https://saas-emagin-optimization-api.info360-dev.com/dev',
		edgeAnalytics: 'https://saas-edge-analytics.info360-dev.com/dev',
	},
};

// TODO: To be migrated vvv vvv vvv vvv vvv vvv vvv vvv vvv
type EnvName = 'dev' | 'qa' | 'prod';

const remapCloudOsEnv = (env: EnvName) => (env === 'qa' ? 'stage' : env);

const generateStandardUrlCloudOs = (subDomain: string, env: EnvName) => {
	// * example: https://saas-edge-manager.wlc360p-c-uw2.autodesk.com
	const region = getRegionName();
	const adskMoniker = constructAdskMoniker('wlc360p', env, region as never);
	const adskMonikerLow = adskMoniker?.toLowerCase();
	const adskEnv = remapCloudOsEnv(env);
	return `https://${subDomain}.${adskMonikerLow}.autodesk.com/${adskEnv}`;
};

const sam = 'saas-asset-management';
const sem = 'saas-edge-manager';

export const serviceMapCloudOsPartial: () => PartialServiceMap = () => {
	return {
		[Environments.LOCAL]: {
			assets: generateStandardUrlCloudOs(sam, 'dev'),
			assetsV2: generateStandardUrlCloudOs(sam, 'dev').concat('/v2'),
			edgeManager: generateStandardUrlCloudOs(sem, 'dev'),
		},
		[Environments.DEV]: {
			assets: generateStandardUrlCloudOs(sam, 'dev'),
			assetsV2: generateStandardUrlCloudOs(sam, 'dev').concat('/v2'),
			edgeManager: generateStandardUrlCloudOs(sem, 'dev'),
		},
		[Environments.QA]: {
			assets: generateStandardUrlCloudOs(sam, 'qa'),
			assetsV2: generateStandardUrlCloudOs(sam, 'qa').concat('/v2'),
			edgeManager: generateStandardUrlCloudOs(sem, 'qa'),
		},
		[Environments.STAGE]: {
			assets: generateStandardUrlCloudOs(sam, 'qa'),
			assetsV2: generateStandardUrlCloudOs(sam, 'qa').concat('/v2'),
			edgeManager: generateStandardUrlCloudOs(sem, 'qa'),
		},
		[Environments.PROD]: {
			assets: generateStandardUrlCloudOs(sam, 'prod'),
			assetsV2: generateStandardUrlCloudOs(sam, 'prod').concat('/v2'),
			edgeManager: generateStandardUrlCloudOs(sem, 'prod'),
		},
	};
};

export default config;
